import { css } from "@emotion/react";

export const globalStyles = css`
  :root {
    --builder-active: #0a6fb7;
    --builder-lighter-blue: #3bc0f7;
    --builder-light-blue: #14bfff;
    --builder-pink: #fd66ff;
    --builder-yellow: #fba929;
    --builder-light-gray: #e5e7e8;

    --builder-text-color: #fff;
    --builder-link-color: #0a7eb3;

    --builder-close-button: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjMyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KIDxnPgogIDx0aXRsZT5MYXllciAxPC90aXRsZT4KICA8ZyBpZD0ibGF5ZXIxIj4KICAgPHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjAuMjVwdCIgaWQ9InBhdGg0OTUwIiBkPSJtMTAwLDYwbC00MCw0MGwxNzAsMTcwbDQwLC00MGwtMTcwLC0xNzB6Ii8+CiAgIDxwYXRoIGZpbGw9IiNmZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLXdpZHRoPSIwLjI1cHQiIGlkPSJwYXRoNDk1MiIgZD0ibTYwLDIzMGwxNzAsLTE3MGw0MCw0MGwtMTcwLDE3MGwtNDAsLTQweiIvPgogIDwvZz4KIDwvZz4KPC9zdmc+Cg==");
    --builder-close-button-active-color: #fff;
    --builder-close-button-active-bg-color: rgb(0 0 0 / 30%);
    --builder-close-button-hover-color: #fff;
    --builder-close-button-hover-bg-color: #c83b3d;

    --builderdefault-background: #2c3134;
    --builder-canvas-background: radial-gradient(#262a2d, #212527);
    --builder-canvas-iframe-shadow: 0 0 10px rgb(0 0 0 / 20%);
    --builder-canvas-addon-button-shadow: 1px 1px 10px rgb(0 0 0 / 20%);

    /* Scrollbar */
    --builder-scrollbar: rgba(0, 0, 0, 0.2);
    --builder-scrollbar-thumb: #677073;
    --builder-scrollbar-thumb-hover: #767f82;

    /* Toolbars */
    --builder-component-bar-background: linear-gradient(#4b5256, #3d4448);
    --builder-toolbar-background: #4d575f;
    --builder-toolbar-highlight: rgba(0, 0, 0, 0.2);
    --builder-toolbar-shadow: 0 1px 2px rgb(0 0 0 / 20%);

    /* Panels */
    --builder-panel-group-background: #32373a;
    --builder-panel-background: #2f3438;
    --builder-option-border-color: #3b4144;
    --builder-panel-border-outer: #24282b;
    --builder-panel-loader: #fff;
    --builder-tabs-background: #272d2f;
    --builder-tabs-inactive-color: #97989a;
    --builder-panel-find-background: #3d4347;
    --builder-panel-find-placeholder: #aaa;
    --builder-editor-find-background: #282c2f;
    --builder-editor-background: #24282b;
    --builder-editor-panel-background: linear-gradient(
      var(--builder-tabs-background),
      var(--builder-tabs-background) 26px,
      var(--builder-panel-group-background) 72px
    );
    --builder-editor-panel-toolbar-shadow: 0 1px 1px rgb(0 0 0 / 20%);
    --builder-detach-button-color: #a9a9a9;
    --builder-tree-item-highlight: rgba(10, 111, 183, 0.34);

    --builder-search-highlight: rgba(215, 210, 28, 0.16);
    --builder-search-highlight-current: rgba(255, 248, 25, 0.82);

    --builder-style-target-btn: rgba(0, 0, 0, 0.2);
    --builder-style-target-btn-hover: rgb(0 0 0 / 30%);
    --builder-style-target-class: var(--builder-editor-green);
    --builder-style-target-id: #fd62ff;

    --builder-option-label-color: #b3babd;
    --builder-option-tooltip-color: var(--builder-option-label-color);
    --builder-smarteditable-active: rgba(255, 255, 255, 0.1);
    --builder-list-item-highlight: rgba(255, 255, 255, 0.05);
    --builder-suggestion-tooltip: #191c1e;

    --builder-badge-custom-options: #00ff80;

    --builder-border-option-active-color: #54cdff;
    --builder-border-option-changes-background: var(--builder-filter-button);
    --builder-border-option-changes-active-background: var(
      --builder-button-dark-active
    );
    --builder-border-option-icon-base: rgba(255, 255, 255, 0.2);
    --builder-border-option-icon-changes-base: rgba(84, 205, 255, 0.4);
    --builder-border-option-icon-radius-base: var(
      --builder-border-option-icon-base
    );
    --builder-border-option-icon-radius-changes-base: var(
      --builder-border-option-icon-changes-base
    );
    --builder-border-option-icon-radius-accent: #fff;

    /* Inputs */
    --builder-input-background: #41474c;
    --builder-input-box-shadow: none;
    --builder-selector-dropdown-box-shadow: 0 0 0 1px
      var(--builder-panel-background);
    --builder-input-addon-divider: var(--builder-option-border-color);
    --builder-search-input-border: #26292b;
    --builder-input-addon: linear-gradient(to bottom, #5e6871, #535d67);
    --builder-input-locked-color: #eee;
    --builder-input-locked-background: #34393e;
    --builder-textbox-background: var(--builder-input-background);
    --builder-focus-outline: #0a6fb7;

    /* Range */
    --builder-range-thumb: #fff;
    --builder-range-background: var(--builder-active);

    /* Dropdowns */
    --builder-dropdown-arrow: url("../img/triangle.svg");
    --builder-dropdown-arrow-light: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='11px' height='7px'%3E%3Cpath fill-rule='evenodd' fill='rgb(148, 153, 165)' d='M10.759,1.920 L6.979,5.700 C6.979,5.700 5.946,6.711 5.487,6.632 C5.029,6.711 3.996,5.700 3.996,5.700 L0.216,1.920 C-0.098,1.607 -0.098,1.098 0.216,0.784 L0.784,0.216 C1.098,-0.098 1.607,-0.098 1.920,0.216 L5.487,3.783 L9.055,0.216 C9.368,-0.098 9.877,-0.098 10.191,0.216 L10.759,0.784 C11.073,1.098 11.073,1.607 10.759,1.920 Z'/%3E%3C/svg%3E");

    /* Buttons */
    --builder-button-option: #555c63;
    --builder-button-option-border: #2f3335;

    --builder-filter-button: #555c63;
    --builder-filter-button-border: #2f3335;

    --builder-button-dark: linear-gradient(#60696d, #3e4648);
    --builder-button-dark-active: linear-gradient(#43494c, #383e40);
    --builder-button-dark-border: #2c3033;
  }

  /* Chrome scrollbars */

  ::-webkit-scrollbar {
    height: 6px;
    width: 6px;
    background: var(--builder-scrollbar);
  }

  ::-webkit-scrollbar-thumb {
    background: var(--builder-scrollbar-thumb);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--builder-scrollbar-thumb-hover);
  }

  ::-webkit-scrollbar-corner {
    display: none;
  }
`;
